import { render } from "./QuizView.vue?vue&type=template&id=0ddb5075&scoped=true"
import script from "./QuizView.vue?vue&type=script&lang=js"
export * from "./QuizView.vue?vue&type=script&lang=js"

import "./QuizView.vue?vue&type=style&index=0&id=0ddb5075&scoped=true&lang=css"
import "./QuizView.vue?vue&type=style&index=1&id=0ddb5075&lang=css"

import exportComponent from "/codebuild/output/src821934687/src/cuco-prova-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddb5075"]])

export default __exports__